import type { SearchConditions } from '~/types/search-conditions';
import type { MasterData } from '~/types/master-data';
import { generateStaticPath } from './generate-static-path';
import { generateDynamicPath } from './generate-dynamic-path';

export const generatePath = (
  searchConditions: SearchConditions,
  masterData: MasterData,
): string => {
  // 静的なパスが存在する場合はそのパスを返す
  const staticPath = generateStaticPath({
    searchConditions,
    masterData,
  });
  if (staticPath) {
    return staticPath;
  } else {
    // 静的なパスが存在しない場合は動的なパスを返す
    const dynamicPath = generateDynamicPath(searchConditions);
    return dynamicPath;
  }
};
